import { Building2, FlaskConical, Rocket, Landmark, CalendarDays } from "lucide-react";
import { usePageMeta } from "@/lib/usePageMeta";
import { Eyebrow, SectionHeading, ButtonLink } from "@/components/site/Content";
import { NetworkGraphic, IllustrativeBadge } from "@/components/site/Brand";
import { Swappable } from "@/components/site/Media";
import { useCopy } from "@/lib/copy";
import { Rich } from "@/components/site/Rich";

const SCOPE = [Building2, FlaskConical, Rocket, Landmark, CalendarDays];

export default function Repository() {
  const t = useCopy();
  usePageMeta("Bengaluru Ecosystem Visualiser", "Information about BRaIN's planned Bengaluru Ecosystem Visualiser.");
  return (
    <>
      <section className="bg-brand text-white" data-testid="repository-hero">
        <div className="container-x grid items-center gap-12 py-16 md:py-24 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <Eyebrow dark className="mb-4">{t("repository.header.eyebrow")}</Eyebrow>
            <h1 className="text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">{t("repository.header.title")}</h1>
            {t("repository.header.badge") && <div className="mt-6"><IllustrativeBadge tone="dark" label={t("repository.header.badge")} /></div>}
            <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/80" data-testid="repository-intro"><Rich text={t("repository.header.intro")} /></p>
          </div>
          <figure className="lg:col-span-5">
            <div className="border border-white/15 p-6"><Swappable src={t("repository.header.image")} alt={t("repository.header.imageAlt")} className="w-full object-contain"><NetworkGraphic className="w-full" animated /></Swappable></div>
            {t("repository.header.caption") && <figcaption className="mt-3 text-xs text-white/60">{t("repository.header.caption")}</figcaption>}
          </figure>
        </div>
      </section>

      <section className="container-x py-16 md:py-24" aria-labelledby="scope-heading">
        <SectionHeading id="scope-heading" eyebrow={t("repository.scope.eyebrow")} title={t("repository.scope.title")} intro={t("repository.scope.intro")} />
        <ul className="grid gap-px bg-line sm:grid-cols-2 lg:grid-cols-5">
          {SCOPE.map((Icon, i) => (
            <li key={i} className="bg-white p-6" data-testid={`repository-scope-${i + 1}`}>
              <Icon className="h-6 w-6 text-brand" aria-hidden="true" />
              <h3 className="mt-4 font-extrabold text-brand">{t(`repository.scope${i + 1}.title`)}</h3>
              <p className="mt-2 whitespace-pre-line text-sm leading-relaxed text-ink-muted">{t(`repository.scope${i + 1}.text`)}</p>
            </li>
          ))}
        </ul>
      </section>

      <section className="container-x pb-16 md:pb-24">
        <div className="flex flex-col items-start justify-between gap-6 bg-pale p-8 md:flex-row md:items-center md:p-12" data-testid="repository-status">
          <div>
            <h2 className="text-2xl font-extrabold text-brand">{t("repository.status.title")}</h2>
            <p className="mt-2 max-w-xl whitespace-pre-line text-ink-muted">{t("repository.status.text")}</p>
          </div>
          <ButtonLink to="/contact" testId="repository-contact-link">{t("repository.status.button")}</ButtonLink>
        </div>
      </section>
    </>
  );
}
